/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";

//dialog imports
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";

import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import classes from "./customer.module.css";
import FormControl from "@mui/material/FormControl";
import CardPaymentIcon from "react-payment-icons";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddressDetails from "./addressDetails";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
// import { makeStyles } from '@mui/styles';

const PaymentMethodDialog = (props) => {
  const t = props.t;
  //TODO: set all details
  const [cardDetails, setCardDetails] = useState({
    cardNumber: "",
    firstNameOnCard: "",
    lastNameOnCard: "",
    expireMonth: "",
    expireYear: "",
    cardType: "",
    cardLogoId: "",
    isPrimary: props.isFirstPaymentMethod ? true : false,
  });

  //TODO: set all details
  const [bankAccount, setBankAccountDetails] = useState({
    bankAccount: "",
    routingNumber: "",
    nameOnAccount: "",
    accountNumber: "",
    isPrimary: props.isFirstPaymentMethod ? true : false,
  });

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '40vw',
  //     },
  // });
  // const classess = useStyles();

  useEffect(() => {}, []);

  const onChange = (e) => {
    if (
      e.target.name === "cardNumber" ||
      e.target.name === "routingNumber" ||
      e.target.name === "accountNumber"
    ) {
      if (isNaN(e.target.value)) {
        e.preventDefault();
      } else {
        if (props.paymentMethodType === "CREDIT_CARD") {
          if (e.target.name === "cardNumber") {
            let cardType = "";
            let cardLogoId = "";

            //American Express
            if (e.target.value[0] === "3") {
              cardLogoId = "amex";
              cardType = "CCT_AMERICANEXPRESS";
            }
            //visa
            else if (e.target.value[0] === "4") {
              cardLogoId = "visa";
              cardType = "CCT_VISA";
            }
            //MasterCard
            else if (e.target.value[0] === "5" || e.target.value[0] === "2") {
              cardLogoId = "mastercard";
              cardType = "CCT_MASTERCARD";
            }
            //others : add a valid message
            else {
              cardLogoId = "";
              cardType = "";
            }
            setCardDetails({
              ...cardDetails,
              [e.target.name]: e.target.value,
              cardType,
              cardLogoId,
            });
          } else {
            setCardDetails({
              ...cardDetails,
              [e.target.name]: e.target.value,
            });
          }
        } else if (props.paymentMethodType === "EFT_ACCOUNT") {
          setBankAccountDetails({
            ...bankAccount,
            [e.target.name]: e.target.value,
          });
        }
      }
    } else {
      if (props.paymentMethodType === "CREDIT_CARD") {
        setCardDetails({
          ...cardDetails,
          [e.target.name]: e.target.value,
        });
      } else if (props.paymentMethodType === "EFT_ACCOUNT") {
        setBankAccountDetails({
          ...bankAccount,
          [e.target.name]: e.target.value,
        });
      }
    }
  };

  const setPrimaryMethod = (e) => {
    if (props.paymentMethodType === "CREDIT_CARD") {
      setCardDetails({
        ...cardDetails,
        [e.target.name]: e.target.checked,
      });
    } else if (props.paymentMethodType === "EFT_ACCOUNT") {
      setBankAccountDetails({
        ...bankAccount,
        [e.target.name]: e.target.checked,
      });
    }
  };

  const setPaymentBillingAddress = (address, index) => {
    if (props.paymentMethodType === "CREDIT_CARD") {
      setCardDetails({
        ...cardDetails,
        billingContactMechId: address.postalMechId,
        billingZip: address.zip,
        billingCity: address.city,
        billingState: address.state,
        billingStreet1: address.street1,
        billingStreet2: address.street2,
        billingCountry: address.country,
        billingAttention: address.attention,
      });
    } else if (props.paymentMethodType === "EFT_ACCOUNT") {
      setBankAccountDetails({
        ...bankAccount,
        billingContactMechId: address.postalMechId,
        billingZip: address.zip,
        billingCity: address.city,
        billingState: address.state,
        billingStreet1: address.street1,
        billingStreet2: address.street2,
        billingCountry: address.country,
        billingAttention: address.attention,
      });
    }
  };

  return (
    <Dialog
      disableScrollLock={true}
      open={props.open}
      PaperComponent={DraggableDialogPaper}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth={"sm"}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
    >
      {/* <DialogTitle id="form-dialog-title" className={classes.paymentMethods}>{props.dialogTitle}</DialogTitle> */}
      <DialogTitle
        id="draggableDialogPaper"
        style={{ cursor: "move" }}
        className={classes.paymentMethods}
      >
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {props.paymentMethodType === "CREDIT_CARD" &&
              t("CREDIT_CARD_DETAILS")}
            {props.paymentMethodType === "EFT_ACCOUNT" &&
              t("BANK_ACCOUNT_DETAILS")}
          </span>
          <Tooltip title={t("CLOSE")}>
            <IconButton
              onTouchStart={() => props.close()}
              onClick={() => props.close()}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {props.paymentMethodType === "CREDIT_CARD" && (
            <>
              {/* <Grid item xs={3}> {t('CARD_NUMBER')} </Grid> */}
              {/* <Grid item xs={2}>
                            </Grid> */}
              {/* <Grid item xs={12}>
                                <CardPaymentIcon id={cardDetails.cardLogoId} style={{ height: 32, marginRight: 16 }} className="payment-icon" />
                                <Input
                                    size={'small'}
                                    variant={'outlined'}
                                    name={'cardNumber'}
                                    placeholder={t('CARD_NUMBER') + ' *'}
                                    value={cardDetails.cardNumber}
                                    onChange={event => onChange(event)}
                                    style={{ width: 'calc(100% - 69px)' }}
                                />
                            </Grid> */}
              <Grid
                item
                style={{ display: "flex", alignItems: "center" }}
                size={{
                  xs: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    position: "relative",
                  }}
                >
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    name={"cardNumber"}
                    placeholder={t("CARD_NUMBER") + " *"}
                    value={cardDetails.cardNumber}
                    onChange={(event) => onChange(event)}
                    style={{ width: "100%" }}
                  />
                  {cardDetails.cardLogoId && (
                    <CardPaymentIcon
                      id={cardDetails.cardLogoId}
                      style={{
                        height: 24,
                        position: "absolute",
                        right: 12,
                        pointerEvents: "none",
                      }}
                      className="payment-icon"
                    />
                  )}
                </div>
              </Grid>

              {/* <Grid item xs={3}> {t('FIRST_NAME')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"firstNameOnCard"}
                  placeholder={t("FIRST_NAME_ON_CARD") + " *"}
                  value={cardDetails.firstNameOnCard}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={3}> {t('LAST_NAME')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"lastNameOnCard"}
                  placeholder={t("LAST_NAME_ON_CARD") + " *"}
                  value={cardDetails.lastNameOnCard}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={3}> {t('Expiration Date')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="expireMonth">
                    {t("EXPIRY_MONTH") + " *"}
                  </InputLabel>
                  <Select
                    native
                    label={t("EXPIRY_MONTH") + " *"}
                    onChange={(event) => onChange(event)}
                    value={cardDetails.expireMonth}
                    inputProps={{
                      name: "expireMonth",
                      id: "expireMonth",
                    }}
                  >
                    <option value="" disabled></option>
                    {props.months.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="expireYear">
                    {t("EXPIRY_YEAR") + " *"}
                  </InputLabel>
                  <Select
                    native
                    label={t("EXPIRY_YEAR") + " *"}
                    onChange={(event) => onChange(event)}
                    value={cardDetails.expireYear}
                    inputProps={{
                      name: "expireYear",
                      id: "expireYear",
                    }}
                  >
                    <option value="" disabled selected></option>
                    {props.years.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={3}></Grid> */}
              {props.screen !== "invoicePayment" && (
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  &nbsp;&nbsp;
                  {props.isFirstPaymentMethod ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="round"
                          // color="primary"
                          name={"isPrimary"}
                          checked={true}
                          readOnly={true}
                        />
                      }
                      label={t("SET_AS_DEFAULT")}
                      onChange={(event) => setPrimaryMethod(event)}
                    />
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          className="round"
                          // color="primary"
                          name={"isPrimary"}
                          checked={cardDetails.isPrimary}
                        />
                      }
                      label={t("SET_AS_DEFAULT")}
                      onChange={(event) => setPrimaryMethod(event)}
                    />
                  )}
                </Grid>
              )}

              {/* <Grid item xs={12} className={classes.paymentMethods}>{t('BILLING_ADDRESS') + ' *'}</Grid> */}

              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <AddressDetails
                  tabValue="1"
                  screen="paymentMethod"
                  setPaymentBillingAddress={setPaymentBillingAddress}
                  addressDetails={props.billingAddressList}
                />
              </Grid>
            </>
          )}
          {props.paymentMethodType === "EFT_ACCOUNT" && (
            <>
              {/* <Grid item xs={5}> {t('BANK_NAME')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"bankName"}
                  placeholder={t("BANK_NAME") + " *"}
                  value={bankAccount.bankName}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={5}> {t('NAME_ON_ACCOUNT')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"nameOnAccount"}
                  placeholder={t("NAME_ON_ACCOUNT") + " *"}
                  value={bankAccount.nameOnAccount}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={5}> {t('Bank Routing Number')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"routingNumber"}
                  placeholder={t("ROUTING_NUMBER_9_DIGIT") + " *"}
                  value={bankAccount.routingNumber}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={5}> {t('Checking Account Number')} </Grid> */}
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name={"accountNumber"}
                  placeholder={t("ACCOUNT_NUMBER_UP_TO_17_DIGITS") + " *"}
                  value={bankAccount.accountNumber}
                  onChange={(event) => onChange(event)}
                />
              </Grid>

              {/* <Grid item xs={5}></Grid> */}
              {props.screen !== "invoicePayment" && (
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  &nbsp;&nbsp;
                  {props.isFirstPaymentMethod ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={"isPrimary"}
                          checked={true}
                          readOnly={true}
                        />
                      }
                      label={t("SET_AS_DEFAULT")}
                      onChange={(event) => setPrimaryMethod(event)}
                    />
                  ) : (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={"isPrimary"}
                          checked={bankAccount.isPrimary}
                        />
                      }
                      label={t("SET_AS_DEFAULT")}
                      onChange={(event) => setPrimaryMethod(event)}
                    />
                  )}
                </Grid>
              )}

              {/* <Grid item xs={12} className={classes.paymentMethods}>{t('BILLING_ADDRESS') + ' *'}</Grid> */}

              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <AddressDetails
                  tabValue="1"
                  screen="paymentMethod"
                  addressDetails={props.billingAddressList}
                  setPaymentBillingAddress={setPaymentBillingAddress}
                />
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent:
            props.dataError && props.dataError.show
              ? "space-between"
              : "flex-end",
        }}
      >
        {props.dataError && props.dataError.show ? (
          <span item xs={12} className={classes.paymentMethodsError}>
            {props.dataError.message}
          </span>
        ) : (
          <></>
        )}
        <div>
          {/* <Button onClick={event => props.close()} color="primary" style={{ marginRight: '10px' }}>{t('CANCEL')}</Button> */}
          <Button
            onClick={(event) =>
              props.close(
                props.paymentMethodType === "CREDIT_CARD"
                  ? cardDetails
                  : bankAccount,
              )
            }
            color="primary"
          >
            {props.invoicePayment ? <>{t("PAY")}</> : <>{t("ADD")}</>}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(PaymentMethodDialog),
);
